/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Route_Error_DescriptionInputs */

const en_route_error_description = /** @type {(inputs: Route_Error_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`The route crashed while rendering. Try again or go back.`)
};

const es_route_error_description = /** @type {(inputs: Route_Error_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`La ruta fallo al renderizar. Intenta de nuevo o regresa.`)
};

/**
* | output |
* | --- |
* | "The route crashed while rendering. Try again or go back." |
*
* @param {Route_Error_DescriptionInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const route_error_description = /** @type {((inputs?: Route_Error_DescriptionInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Route_Error_DescriptionInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_route_error_description(inputs)
	return es_route_error_description(inputs)
});